/**
 * Auth helpers for Python Lab — re-uses the same Emergent Google session
 * pattern as the Call Analyzer.
 */

export function getStoredUser() {
  try {
    const raw = sessionStorage.getItem("user_data");
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function getAuthHeaders() {
  const u = getStoredUser();
  if (u?.session_token) {
    return { Authorization: `Bearer ${u.session_token}` };
  }
  return {};
}

export function getAuthConfig() {
  const u = getStoredUser();
  if (u?.session_token) {
    return { headers: { Authorization: `Bearer ${u.session_token}` } };
  }
  return { withCredentials: true };
}

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function loginWithGoogle(returnPath) {
  const path = returnPath || (window.location.pathname + window.location.search);
  const state = Math.random().toString(36).slice(2) + Date.now().toString(36);
  sessionStorage.setItem("g_oauth_state", state);
  sessionStorage.setItem("g_oauth_return", path);
  const params = new URLSearchParams({
    client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    redirect_uri: window.location.origin + "/auth/google",
    response_type: "code",
    scope: "openid email profile",
    prompt: "select_account",
    state,
  });
  window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
}

export function clearStoredUser() {
  sessionStorage.removeItem("user_data");
  localStorage.removeItem("ai_tools_token");
}
